import { useEffect } from 'react';
import { useCallbackRef } from './useCallbackRef.js';

function useSVGBlurEvent({
  checkFn = () => true,
  onBlur,
  ref
}) {
  const checkFnCallback = useCallbackRef(checkFn);
  useEffect(() => {
    const handleBlur = event => {
      const currentTarget = event.currentTarget;
      requestAnimationFrame(() => {
        if (!currentTarget.contains(document.activeElement) && checkFnCallback(document.activeElement)) {
          onBlur(event);
        }
      });
    };

    ref === null || ref === void 0 ? void 0 : ref.addEventListener('focusout', handleBlur);
    return () => {
      ref === null || ref === void 0 ? void 0 : ref.removeEventListener('focusout', handleBlur);
    };
  }, [checkFnCallback, onBlur, ref]);
}

export { useSVGBlurEvent };
